export type DemoPoint = { x: number; y: number };

export type DemoRect = {
	left: number;
	top: number;
	right: number;
	bottom: number;
	width: number;
	height: number;
};

export const rectWithin = (container: HTMLElement, element: Element): DemoRect => {
	const scale =
		Number(container.closest('[data-preview-scale]')?.getAttribute('data-preview-scale')) || 1;
	const containerBox = container.getBoundingClientRect();
	const box = element.getBoundingClientRect();
	const left = (box.left - containerBox.left) / scale;
	const top = (box.top - containerBox.top) / scale;
	const width = box.width / scale;
	const height = box.height / scale;

	return { left, top, right: left + width, bottom: top + height, width, height };
};

export const centerOf = (rect: DemoRect): DemoPoint => ({
	x: rect.left + rect.width / 2,
	y: rect.top + rect.height / 2,
});
